export default __webpack_public_path__ + "static/media/no-image.b4956f30.jpg";